import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthContext } from '../services/auth.context';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private authContext: AuthContext, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const requiredRoles: string[] = route.data['roles']; // Get allowed roles from route data
    if (localStorage.getItem('user_info')) {
      if (Boolean(localStorage.getItem('userLoggedIn')) && requiredRoles.includes(JSON.parse(localStorage.getItem('user_info') as string).userType)) {
        return true; // User has required role
      }
    } else {
      this.router.navigate(['/app/login']);
      return false; // User has required role
    }

    // Redirect to login or unauthorized page
    this.router.navigate(['/app/unauthorized']);
    return false; // Access denied
  }
}
